import { DateTime } from "luxon"

/**
 * The arg !== arg is a tricky way to detect NaN
 */
const hasNoValue = (arg) =>
  arg === null ||
  arg === undefined ||
  // eslint-disable-next-line no-self-compare
  arg !== arg ||
  (Array.isArray(arg) && arg.length === 0)

const defaultFormulas = {
  equal: (arg1, arg2) => {
    const arg1IsArray = Array.isArray(arg1)
    const arg2IsArray = Array.isArray(arg2)

    if (arg1IsArray && arg2IsArray) {
      return (
        arg1.some((x) => arg2.includes(x)) || arg2.some((x) => arg1.includes(x))
      )
    }

    if (arg1IsArray && !arg2IsArray) {
      return arg1.includes(arg2)
    }

    if (!arg1IsArray && arg2IsArray) {
      return arg2.includes(arg1)
    }

    return arg1 === arg2
  },

  sum: (input) => {
    if (input.some(isNaN)) throw Error("'sum' formula accepts only numbers.")
    return input.reduce((total, el) => total + el, 0)
  },

  count: (input) => {
    return input.length
  },

  ifNull: (arg1, arg2) => {
    const arg1IsNull = hasNoValue(arg1)
    const arg2IsNull = hasNoValue(arg2)

    return arg1IsNull ? (arg2IsNull ? null : arg2) : arg1
  },

  isNull: hasNoValue,

  condition: (exp, valueIfTrue, valueIfFalse) => {
    if (hasNoValue(exp) || exp === false) {
      return valueIfFalse
    }

    return valueIfTrue
  },

  contains: (arg1, arg2) => {
    if (hasNoValue(arg1)) {
      return false
    }

    if (Array.isArray(arg1)) {
      return arg1.includes(arg2)
    }

    if (typeof arg1 !== "string") {
      throw Error("First argument of 'contains' must be an array or string.")
    }

    return arg1.indexOf(arg2) !== -1
  },

  startsWith: (arg1, arg2) => {
    return arg1.startsWith(arg2)
  },

  not: (arg) => {
    return !arg
  },

  date: (arg) => {
    if (hasNoValue(arg)) return NaN
    return DateTime.fromISO(arg).valueOf()
  },
}

const builtInFormulaAliases = {
  pow: "Math.pow",
}

export { defaultFormulas, builtInFormulaAliases }
